<template>
  <ThreeColumn :breadcrumbPaths="paths">
    <template v-slot:title>
      <h1 class="text-h1 mb-0">{{$t('donors.page_title')}}</h1>
    </template>

    <template v-slot:mainPanel>
      <p>{{$t('donors.intro[0]')}}</p>

      <v-row class="pb-8">
        <!--Current Donors--->
        <v-col cols="12" sm="6" md="4">
          <v-divider class="my-3"></v-divider>
        <h2 class="text-h2 liiblack--text pb-2">{{$t('donors.curr')}}</h2> 
        <h3 v-if="donors.current.individuals.length>0" class="text-h3 navlink--text pb-2">{{$t('donors.indi')}}</h3> 
        <div class="pb-4">
          <p v-for="(name, idx) in donors.current.individuals" :key="'cur_indi' + idx" class="donor-name">
            {{name}}
          </p>
        </div>
        <h3 v-if="donors.current.law_firms.length>0" class="text-h3 navlink--text pb-2">{{$t('donors.firm')}}</h3> 
        <div>
          <p v-for="(name, idx) in donors.current.law_firms" :key="'cur_firm' + idx" class="donor-name">
            {{name}}
          </p>
        </div>
        </v-col>
        
        <!--Past Donors--->
        <v-col cols="12" sm="6" md="8">
          <v-divider class="my-3"></v-divider>
          <h2 class="text-h2 liiblack--text pb-2">{{$t('donors.past')}}</h2> 
          <h3 v-if="donors.past.individuals.length>0" class="text-h3 navlink--text pb-2">{{$t('donors.indi')}}</h3> 
          <div :class="$vuetify.breakpoint.mdAndUp? 'pb-4 col-overflow' : 'pb-4'">
            <p v-for="(name, idx) in donors.past.individuals" :key="'past_indi' + idx" class="donor-name">
              {{name}}
            </p>
          </div>
          <h3 v-if="donors.past.law_firms.length>0" class="text-h3 navlink--text pb-2">{{$t('donors.firm')}}</h3> 
          <div>
            <p v-for="(name, idx) in donors.past.law_firms" :key="'past_firm' + idx" class="donor-name">
              {{name}}
            </p>
          </div>
        </v-col>

      </v-row>

      <!--Thank you message-->
      <v-row class="pb-8">
        <i18n path="donors.thanks[0]" tag="p">
          <a href="https://www.giving.hku.hk/en/Donate/Hong-Kong-Legal-Information-Institute.html" target="_blank">{{$t('donors.donation_page')}}</a>
          <router-link :to="{name: 'feedback'}">{{$t('btntxt.contactus')}}</router-link>
        </i18n>
      </v-row>
    </template>

    <!--Call for Donation Banner-->
    <template v-slot:bottomPanel>
      <div>
        <v-parallax
          height="300"
          style="background: rgb(151,57,74); background: linear-gradient(180deg, rgba(151,57,74,1) -25%, rgba(64,40,40,1) 87%); "
          :src="require('../assets/patterns.png')"
        >
          <v-row
            class="d-flex justify-center"
            align="center"
            justify="center"
          >
            <v-btn 
              x-large elevation="6" color="primary"
              class="white--text cta-donate"
              min-width="230px"
              href="https://eform.giving.hku.hk/zend/online_donation/hong_kong_legal_information_institute" target="_blank">
              <v-icon small color="white" class="mr-5">mdi-sprout</v-icon>
              {{$t('btntxt.donate')}}
            </v-btn>
          </v-row>
        </v-parallax>
      </div>
    </template>
  </ThreeColumn>
</template>

<script>
  import ThreeColumn from '@/components/applayout/ThreeColumn'
  import donors from '@/data/donors.json'
  export default {
    name: "Donors",
    components:{
      ThreeColumn
    },
    data(){
      return {
        donors: donors
      } 
    },
    /*watch:{
      '$i18n.locale': function(){
        window.document.title = `${this.$i18n.t('donors.page_title')} | HKLII`  
      }
    },*/
    computed:{
      paths(){
        return [
          {text: 'HKLII', disabled: false, href: {name: 'home'}},
          {text: this.$i18n.t('donors.page_title'), disabled: true}
        ]
      }
    },
    /*mounted(){
      window.document.title = `${this.$i18n.t('donors.page_title')} | HKLII`
    }*/
    metaInfo(){
      return{
        title: this.$i18n.t('donors.page_title'),
      }
    },
  }
</script>

<style scoped lang="scss">
  @import '@/sass/_typography.scss';

  a {
    @include link-no-underline;
  }
  .cta-donate:hover{ /*remove underline for button*/
    text-decoration: none;
  } 
  .donor-name{
    margin-bottom: 0.6em;
    line-height: 1.12;
  }
  .col-overflow{
    column-count: 2;
    column-gap: 20px;
  }
</style>